import { render, staticRenderFns } from "./ViewApplicantsModule.vue?vue&type=template&id=53cc84b1"
import script from "./ViewApplicantsModule.vue?vue&type=script&lang=ts"
export * from "./ViewApplicantsModule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports